/**
 * PERGOLUX — WhatsApp Widget (self-contained)
 *
 * Substitui completamente o widget do Superchat.
 * - Botão flutuante verde (mobile + desktop)
 * - Mobile: toca → abre WhatsApp via redirect page (com UTMs)
 * - Desktop: clica → painel com QR dinâmico + botão "Abrir WhatsApp Web"
 * - QR com ícone do WhatsApp no centro
 * - Captura UTMs, gclid, fbclid, página de origem
 * - Todo tráfego passa por /pages/chat-whatsapp para tracking
 *
 * INSTALAÇÃO (layout/theme.liquid, antes do </body>):
 *
 *   <script src="https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.min.js"></script>
 *   {{ 'pgx-whatsapp-widget.js' | asset_url | script_tag }}
 *
 * IMPORTANTE: remover/desinstalar o widget do Superchat antes.
 */

(function () {
  'use strict';

  var CONFIG = {
    REDIRECT_PATH: '/pages/chat-whatsapp',
    REDIRECT_BASE: 'https://pergolux.com.br/pages/chat-whatsapp',

    // Posição do botão
    POSITION: 'right', // 'right' ou 'left'
    OFFSET_X: 20,
    OFFSET_Y: 20,

    // Aparência
    BRAND_GREEN: '#25D366',
    BUTTON_SIZE: 60,

    // QR
    QR_SIZE: 200,
    QR_DARK: '#0b0b0c',
    QR_LIGHT: '#ffffff',

    // Textos (Chile — español)
   PANEL_TITLE: 'Olá!',
PANEL_SUBTITLE: 'Fale com a gente pelo WhatsApp',
QR_INSTRUCTION: 'Escaneie o QR code agora e converse pelo WhatsApp direto do seu celular:',
BUTTON_LABEL: 'Consulte Condições Especiais',

    // Breakpoint mobile (px)
    MOBILE_BREAKPOINT: 768,
  };

  // Não rodar na própria redirect page
  if (window.location.pathname.indexOf(CONFIG.REDIRECT_PATH) !== -1) return;

  // ---------------------------------------------
  // Captura de parâmetros — FIRST CAMPAIGN-TOUCH
  //
  // Regra: guarda o PRIMEIRO toque de campanha e nunca sobrescreve.
  // Visitas diretas/orgânicas NÃO travam nada.
  //
  // Allow-list: encaminha apenas os params que respondem "qual canal/
  // campanha/anúncio gerou o chat". O resto (hsa_*, loc_*, device,
  // product_*, etc) fica de fora — GA4 já captura geo/device no pageview.
  //
  // Google: template passa utm_source=google&utm_medium=cpc explícito.
  // Fallback: se vier só gclid (auto-tagging), normaliza para google/paid.
  // ---------------------------------------------

  // Params que SÃO encaminhados para a redirect page (allow-list)
  var FORWARD_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'klar_source', 'klar_adid', 'klar_cpid'
  ];

  // Click IDs usados só para DETECTAR toque pago (não necessariamente encaminhados)
  var GOOGLE_CLICK = ['gclid', 'gbraid', 'wbraid'];
  var OTHER_CLICK = ['fbclid', 'ttclid', 'msclkid'];

  function readCampaignTouchFromURL() {
    var urlParams = new URLSearchParams(window.location.search);
    var touch = {};

    // Capturar apenas os params da allow-list
    FORWARD_KEYS.forEach(function (k) { var v = urlParams.get(k); if (v) touch[k] = v; });

    // Detectar sinal de campanha
    var hasUTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
      .some(function (k) { return touch[k]; });
    var hasGoogleClick = GOOGLE_CLICK.some(function (k) { return urlParams.get(k); });
    var hasOtherClick = OTHER_CLICK.some(function (k) { return urlParams.get(k); });

    if (!(hasUTM || hasGoogleClick || hasOtherClick)) return null;

    // Fallback Google auto-tagging: gclid sem utm_source → google/paid
    if (hasGoogleClick && !touch.utm_source) {
      touch.utm_source = 'google';
      touch.utm_medium = touch.utm_medium || 'cpc';
    }
    // Fallback Meta: fbclid sem utm_source → meta/paid
    if (hasOtherClick && urlParams.get('fbclid') && !touch.utm_source) {
      touch.utm_source = 'meta';
      touch.utm_medium = touch.utm_medium || 'paid';
    }

    return touch;
  }

  function getSessionParams() {
    var params = {};

    // 1. Ler toque de campanha armazenado (first touch)
    var storedTouch = null;
    try {
      var stored = localStorage.getItem('pgx_ft');
      if (stored) storedTouch = JSON.parse(stored);
    } catch (e) {}

    // 2. Ler toque da URL atual
    var currentTouch = readCampaignTouchFromURL();

    // 3. FIRST-TOUCH: se já existe armazenado, ele vence. Senão, e se a URL
    //    atual tem um toque de campanha, armazena e usa.
    if (storedTouch) {
      params = storedTouch;
    } else if (currentTouch) {
      params = currentTouch;
      try { localStorage.setItem('pgx_ft', JSON.stringify(currentTouch)); } catch (e) {}
    }
    // Se não há nem armazenado nem atual → params fica vazio (direct/organic)

    // 4. page_source sempre reflete a página onde o chat foi iniciado
    params = Object.assign({}, params);
    params.page_source = window.location.pathname;

    return params;
  }

  function buildRedirectURL() {
    var params = getSessionParams();
    var url = new URL(CONFIG.REDIRECT_BASE);
    Object.keys(params).forEach(function (k) { url.searchParams.set(k, params[k]); });
    return url.toString();
  }

  function isMobile() {
    return window.innerWidth <= CONFIG.MOBILE_BREAKPOINT
      || /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  }

  // ---------------------------------------------
  // Ícone do WhatsApp (SVG) para o botão
  // ---------------------------------------------
  var WA_ICON = '<svg viewBox="0 0 32 32" width="32" height="32" fill="#fff" xmlns="http://www.w3.org/2000/svg">'
    + '<path d="M16.004 0h-.008C7.174 0 .002 7.174.002 16c0 3.498 1.13 6.74 3.05 9.37L1.05 31.02l5.85-1.87A15.9 15.9 0 0016.004 32C24.826 32 32 24.826 32 16S24.826 0 16.004 0zm9.31 22.594c-.386 1.09-1.92 1.995-3.144 2.26-.836.178-1.928.32-5.606-1.204-4.708-1.95-7.738-6.73-7.974-7.04-.226-.31-1.902-2.53-1.902-4.828s1.204-3.42 1.632-3.888c.352-.386.914-.562 1.454-.562.176 0 .334.008.476.016.428.018.642.044.924.72.352.85 1.212 2.95 1.318 3.166.108.216.18.47.036.78-.134.31-.252.446-.468.696-.216.25-.42.44-.636.71-.196.234-.418.486-.17.916.248.42 1.104 1.82 2.372 2.95 1.636 1.458 2.994 1.91 3.472 2.11.356.148.78.112 1.04-.166.33-.356.736-.946 1.15-1.53.294-.418.664-.47 1.052-.324.396.14 2.49 1.174 2.918 1.388.428.214.712.318.82.498.106.18.106 1.03-.28 2.12z"/>'
    + '</svg>';

  // Ícone WhatsApp verde para centro do QR (com fundo branco)
  function drawWhatsAppIconOnQR(ctx, size) {
    var iconSize = size * 0.2;
    var cx = size / 2, cy = size / 2;
    var pad = 5;

    // Fundo branco circular
    ctx.fillStyle = CONFIG.QR_LIGHT;
    ctx.beginPath();
    ctx.arc(cx, cy, iconSize / 2 + pad, 0, Math.PI * 2);
    ctx.fill();

    // Círculo verde WhatsApp
    ctx.fillStyle = CONFIG.BRAND_GREEN;
    ctx.beginPath();
    ctx.arc(cx, cy, iconSize / 2, 0, Math.PI * 2);
    ctx.fill();

    // Glifo do WhatsApp (desenhado como imagem SVG)
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="' + iconSize + '" height="' + iconSize + '">'
      + '<path fill="#fff" d="M16.004 4C9.38 4 4 9.38 4 16c0 2.62.85 5.05 2.29 7.03L4.79 27.2l4.3-1.4A11.9 11.9 0 0016 28c6.62 0 12-5.38 12-12S22.62 4 16.004 4zm6.98 16.95c-.29.82-1.44 1.5-2.36 1.7-.63.13-1.45.24-4.2-.9-3.53-1.46-5.8-5.04-5.98-5.28-.17-.23-1.43-1.9-1.43-3.62 0-1.72.9-2.56 1.22-2.92.26-.29.69-.42 1.1-.42.13 0 .25.006.36.012.32.014.48.033.7.54.26.64.9 2.2.98 2.36.08.16.13.35.03.58-.1.23-.19.34-.35.52-.16.18-.34.4-.48.54-.16.18-.32.37-.14.7.18.33.83 1.37 1.78 2.22 1.23 1.1 2.26 1.43 2.6 1.58.27.11.58.08.79-.13.25-.27.55-.71.86-1.15.22-.31.5-.35.79-.24.3.1 1.87.88 2.19 1.04.32.16.53.24.61.37.08.14.08.78-.21 1.6z"/>'
      + '</svg>';
    var img = new Image();
    var blob = new Blob([svg], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    img.onload = function () {
      ctx.drawImage(img, cx - iconSize / 2, cy - iconSize / 2, iconSize, iconSize);
      URL.revokeObjectURL(url);
    };
    img.src = url;
  }

  // ---------------------------------------------
  // Renderizar QR em canvas
  // ---------------------------------------------
  function renderQR(canvas) {
    var size = CONFIG.QR_SIZE;
    canvas.width = size; canvas.height = size;
    canvas.style.width = size + 'px'; canvas.style.height = size + 'px';
    var ctx = canvas.getContext('2d');

    var qr = qrcode(0, 'H');
    qr.addData(buildRedirectURL());
    qr.make();

    var count = qr.getModuleCount();
    var quiet = 2;
    var cell = size / (count + quiet * 2);

    ctx.fillStyle = CONFIG.QR_LIGHT;
    ctx.fillRect(0, 0, size, size);
    ctx.fillStyle = CONFIG.QR_DARK;
    for (var r = 0; r < count; r++) {
      for (var c = 0; c < count; c++) {
        if (qr.isDark(r, c)) {
          ctx.fillRect((c + quiet) * cell, (r + quiet) * cell, cell + 0.5, cell + 0.5);
        }
      }
    }
    drawWhatsAppIconOnQR(ctx, size);
  }

  // ---------------------------------------------
  // Estilos
  // ---------------------------------------------
  function injectStyles() {
    var css = ''
      + '#pgx-wa-btn{position:fixed;bottom:' + CONFIG.OFFSET_Y + 'px;' + CONFIG.POSITION + ':' + CONFIG.OFFSET_X + 'px;'
      + 'width:' + CONFIG.BUTTON_SIZE + 'px;height:' + CONFIG.BUTTON_SIZE + 'px;border-radius:50%;'
      + 'background:' + CONFIG.BRAND_GREEN + ';box-shadow:0 4px 12px rgba(0,0,0,.25);'
      + 'display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:99998;'
      + 'transition:transform .2s ease;border:none;}'
      + '#pgx-wa-btn:hover{transform:scale(1.08);}'
      + '#pgx-wa-btn svg{width:' + (CONFIG.BUTTON_SIZE * 0.55) + 'px;height:' + (CONFIG.BUTTON_SIZE * 0.55) + 'px;}'
      + '#pgx-wa-panel{position:fixed;bottom:' + (CONFIG.OFFSET_Y + CONFIG.BUTTON_SIZE + 12) + 'px;'
      + CONFIG.POSITION + ':' + CONFIG.OFFSET_X + 'px;width:300px;background:#fff;border-radius:16px;'
      + 'box-shadow:0 8px 32px rgba(0,0,0,.2);z-index:99999;overflow:hidden;'
      + 'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;'
      + 'opacity:0;transform:translateY(10px);pointer-events:none;transition:opacity .2s,transform .2s;}'
      + '#pgx-wa-panel.open{opacity:1;transform:translateY(0);pointer-events:auto;}'
      + '.pgx-wa-header{background:' + CONFIG.BRAND_GREEN + ';color:#fff;padding:18px 20px;}'
      + '.pgx-wa-header h3{margin:0 0 4px;font-size:18px;font-weight:700;}'
      + '.pgx-wa-header p{margin:0;font-size:13px;opacity:.95;line-height:1.4;}'
      + '.pgx-wa-body{padding:20px;text-align:center;}'
      + '.pgx-wa-body .instr{font-size:13px;color:#555;margin:0 0 14px;line-height:1.4;}'
      + '.pgx-wa-qr{display:flex;justify-content:center;margin-bottom:16px;}'
      + '.pgx-wa-cta{display:block;width:100%;background:' + CONFIG.BRAND_GREEN + ';color:#fff;'
      + 'border:none;border-radius:8px;padding:12px;font-size:14px;font-weight:600;cursor:pointer;'
      + 'text-decoration:none;box-sizing:border-box;}'
      + '.pgx-wa-cta:hover{filter:brightness(.95);}'
      + '.pgx-wa-close{position:absolute;top:14px;' + (CONFIG.POSITION === 'right' ? 'right' : 'left') + ':14px;'
      + 'background:rgba(255,255,255,.25);border:none;color:#fff;width:24px;height:24px;border-radius:50%;'
      + 'cursor:pointer;font-size:16px;line-height:1;display:flex;align-items:center;justify-content:center;}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ---------------------------------------------
  // Construir widget
  // ---------------------------------------------
  function buildWidget() {
    // Botão flutuante
    var btn = document.createElement('button');
    btn.id = 'pgx-wa-btn';
    btn.setAttribute('aria-label', 'WhatsApp');
    btn.innerHTML = WA_ICON;
    document.body.appendChild(btn);

    // Comportamento por device
    btn.addEventListener('click', function () {
      if (isMobile()) {
        // Mobile: redirect direto
        window.location.href = buildRedirectURL();
      } else {
        // Desktop: abrir painel
        togglePanel();
      }
    });

    // Painel desktop (criado sob demanda)
    var panel = null;

    function buildPanel() {
      panel = document.createElement('div');
      panel.id = 'pgx-wa-panel';
      panel.innerHTML =
        '<div class="pgx-wa-header">'
        + '<button class="pgx-wa-close" aria-label="Cerrar">&times;</button>'
        + '<h3>' + CONFIG.PANEL_TITLE + '</h3>'
        + '<p>' + CONFIG.PANEL_SUBTITLE + '</p>'
        + '</div>'
        + '<div class="pgx-wa-body">'
        + '<p class="instr">' + CONFIG.QR_INSTRUCTION + '</p>'
        + '<div class="pgx-wa-qr"><canvas id="pgx-wa-qr-canvas"></canvas></div>'
        + '<a class="pgx-wa-cta" id="pgx-wa-cta" href="#">' + CONFIG.BUTTON_LABEL + '</a>'
        + '</div>';
      document.body.appendChild(panel);

      renderQR(panel.querySelector('#pgx-wa-qr-canvas'));

      panel.querySelector('.pgx-wa-close').addEventListener('click', togglePanel);
      panel.querySelector('#pgx-wa-cta').addEventListener('click', function (e) {
        e.preventDefault();
        window.open(buildRedirectURL(), '_blank');
      });
    }

    function togglePanel() {
      if (!panel) buildPanel();
      panel.classList.toggle('open');
    }
  }

  // ---------------------------------------------
  // Init
  // ---------------------------------------------
  function init() {
    if (typeof qrcode === 'undefined') {
      console.error('[PGX WA] qrcode-generator not loaded. Add the CDN script before this file.');
      return;
    }
    injectStyles();
    buildWidget();
    console.log('[PGX WA] Widget ready.');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
